import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const FrameComponent3 = ({ className = "" }) => {
  const navigate = useNavigate();

  const onTermClick = useCallback(() => {
    navigate("/31-term-1");
  }, [navigate]);

  return (
    <div
      className={`w-full px-10 pb-[25px] box-border text-center text-sm text-light-text font-text-regular-lowercase ${className}`}
    >
      <p className="m-0 font-medium">
        Khi bạn nhấn vào tạo tài khoản, bạn đã đồng ý với{" "}
        <span
          onClick={onTermClick}
          className="font-semibold text-dark-orange cursor-pointer hover:underline"
        >
          điều khoản sử dụng
        </span>{" "}
        của chúng tôi.
      </p>
    </div>
  );
};

FrameComponent3.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent3;